import { create} from 'zustand';
import { persist, createJSONStorage } from "zustand/middleware";
import { UNIFY_VERSION_KEY } from "./util/clearLocalStorage";

export const useUnifyVersion = create<any>(
  persist(
    (set) => ({
      unifyVersion: 'v1',
      setUnifyVersion: (unifyVersion:string) => set({ unifyVersion}),
    }),
    {
      name: UNIFY_VERSION_KEY, // Local Storage Key (kept across logout)
      storage: createJSONStorage(() => localStorage), // Define Storage Type
    }
  )
);

export const useUnifyER = create<any>(
  persist(
    (set) => ({
      unifyER: 'false',
      setUnifyER: (unifyER:string) => set({ unifyER}),
    }),
    {
      name: "unify-user-er", // Local Storage Key
      storage: createJSONStorage(() => localStorage), // Define Storage Type
    }
  )
);